export var EGLType;
(function (EGLType) {
    EGLType["GAIN"] = "gain";
    EGLType["LOSS"] = "loss";
})(EGLType || (EGLType = {}));
export var EPeriod;
(function (EPeriod) {
    EPeriod["ONE_DAY"] = "1D";
    EPeriod["ONE_WEEK"] = "1WK";
    EPeriod["ONE_MONTH"] = "1MN";
})(EPeriod || (EPeriod = {}));
